import * as React from 'react'
import { useCallback, useMemo } from 'react'
import { Field, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

import MenuItem from '@mui/material/MenuItem'

import { MuiTextFieldFormik } from '@user/components/Formik/MuiTextFieldFormik'
import { selectAllBranches } from '@user/store/branches'

import type { UpdateRequiredFieldsFormModel } from '../typings'

/**
 * Branch select over the branches in the store (depends on the branch list being loaded). Changing
 * the branch clears the sales team and owner, because both are scoped to a branch, as in Add Lead.
 */
export function BranchField() {
  const { setFieldValue } = useFormikContext<UpdateRequiredFieldsFormModel>()
  const allBranches = useSelector(selectAllBranches)
  const branches = useMemo(
    () => allBranches.filter((branch) => branch.active),
    [allBranches],
  )

  const onChangeBranch = useCallback(() => {
    setFieldValue('salesTeamId', null)
    setFieldValue('assigneeId', '')
  }, [setFieldValue])

  return (
    <Field
      name="branchId"
      label="Branch"
      component={MuiTextFieldFormik}
      fullWidth
      select
      required
      onChange={onChangeBranch}
      data-test-id="auto-review-branch"
    >
      {branches.map(({ id, name }) => (
        <MenuItem key={id} value={id}>
          {name}
        </MenuItem>
      ))}
    </Field>
  )
}
BranchField.displayName = 'BranchField'
